import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef } from "react";
import classNames from "classnames";
import { useSignal, useSignalEffect } from "@preact/signals";
import Icon from "../../Icon";
import Button from "../../Button";
import FilterPanel from "../FilterPanel";
import useDocumentSize from "../../../lib/hooks/use-document-size";
import useElementBounds from "../../../lib/hooks/use-element-bounds";
import useOnClickOutside from "../../../lib/hooks/use-on-click-outside";
import style from "./style.module.scss";
export default function FilterPill(props) {
    const { attributes = {}, name, panelTitle = name, options, disabled = false, fullWidth = false, removable = true, open = false, onRemove, children, } = props;
    const isOpen = useSignal(open);
    const filterRef = useRef(null);
    const [filterPanelRef, filterPanelBounds] = useElementBounds();
    const docSize = useDocumentSize();
    // Close the filter when the user clicks outside of it
    useOnClickOutside(filterRef, () => (isOpen.value = false));
    // Run the onOpenChange callback when the open state changes
    useSignalEffect(() => {
        if (props.onOpenChange) {
            props.onOpenChange(isOpen.value);
        }
    });
    // Sync the open state when the parent component changes the prop
    useEffect(() => {
        if (typeof props.open === "boolean") {
            isOpen.value = props.open;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.open]);
    const toggleOpen = () => {
        if (!disabled) {
            isOpen.value = !isOpen.value;
        }
    };
    const removeFilter = () => {
        if (onRemove) {
            onRemove();
        }
    };
    let filterPanelLeft = "0";
    if (filterPanelBounds.width + filterPanelBounds.left > docSize.width) {
        filterPanelLeft = `calc(${docSize.width}px - ${filterPanelBounds.left}px - ${filterPanelBounds.width}px - var(--grid-padding))`;
    }
    return (_jsxs("div", Object.assign({}, attributes, { className: classNames(style["filter-pill"], attributes.className, {
            [style["filter-pill--disabled"]]: disabled,
        }), ref: filterRef, children: [_jsxs("button", { type: "button", className: classNames(style["filter-pill__main"], "qa-filter-pill-button", {
                    [style["filter-pill__main--delete"]]: removable,
                    [style["filter-pill__main--full-width"]]: fullWidth,
                }), onClick: toggleOpen, tabIndex: disabled ? -1 : undefined, children: [_jsxs("div", { className: style["filter-pill__content"], children: [name ? _jsxs("span", { className: style["filter-pill__name"], children: [name, ":"] }) : null, _jsx("span", { className: style["filter-pill__value"], children: getPillValue(options) })] }), disabled === false && (_jsx("div", { className: style["filter-pill__action"], children: _jsx(Icon, { name: "caret--thin--down" }) }))] }), removable ? (_jsxs(Button, { variation: "none", className: style["filter-pill__delete"], onClick: removeFilter, children: [_jsx(Icon, { name: "xmark--thin" }), _jsx("span", { className: "visually-hidden", children: "Remove filter" })] })) : null, isOpen.value ? (_jsx("div", { className: style["filter-pill__edit-panel"], style: { left: filterPanelLeft }, ref: filterPanelRef, children: _jsx(FilterPanel, { title: panelTitle, removable: removable, onRemove: removeFilter, onDone: () => (isOpen.value = false), children: children }) })) : null] })));
}
function getPillValue(options) {
    if (options.length > 2) {
        return `${options[0].label} & ${options.length - 1} others`;
    }
    else if (options.length === 2) {
        return `${options[0].label}, ${options[1].label}`;
    }
    else if (options[0]) {
        return options[0].label;
    }
    return "Any";
}
